import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import type EnpsForm from 'modules/enps/store/models/Form'
import type QuestionGroup from 'modules/surveys/store/models/QuestionGroup'

import ResponseActiveQuestions from './ResponseActiveQuestions'
import ResponseDraftQuestions from './ResponseDraftQuestions'

interface Props {
  form: EnpsForm
  questionGroup: QuestionGroup
  onDraftSaved: () => Promise<void>
}

function ResponseQuestionsWrapper({ form, questionGroup, onDraftSaved }: Props) {
  return (
    <div data-testid="answer-survey">
      <Box gap="s48" padding="s24">
        {(!!form.isDraft || !questionGroup?.id) && (
          <ResponseDraftQuestions formId={form.attributes.id} />
        )}
        {((!!questionGroup?.id && !!questionGroup.isAnswered) || !!form.isFinished) && (
          <ResponseActiveQuestions
            questionGroup={questionGroup}
            onDraftSaved={onDraftSaved}
            canEdit={false}
          />
        )}
        {!!form.isActive && !!questionGroup?.id && !questionGroup.isAnswered && (
          <ResponseActiveQuestions
            questionGroup={questionGroup}
            onDraftSaved={onDraftSaved}
            canEdit
          />
        )}
      </Box>
    </div>
  )
}

export default observer(ResponseQuestionsWrapper)
